import { useState } from 'react';

import { TreatmentRequestAgreement, treatmentRequestAgreements } from '@/models/common';
import { TreatmentRequest } from '@/models/diagnosis';
import { Client, ClientType } from '@/types/app';
import { EDiagnosisContactType } from '@/types/diagnosis';

interface UseTelemedicineAgreementParams {
  treatmentRequest: TreatmentRequest;
  contactType: EDiagnosisContactType;
  updateForm: (updater: (prev: any) => any) => void;
  client: Client;
}

export const useTelemedicineAgreement = ({
  treatmentRequest,
  contactType,
  updateForm,
  client,
}: UseTelemedicineAgreementParams) => {
  const [requestAgreementList, setRequestAgreementList] = useState<TreatmentRequestAgreement[]>(
    treatmentRequestAgreements.filter((agreement) => agreement.contactTypeList.includes(contactType))
  );

  const toggleTreatmentRequestAgreement = (selectedTerm: TreatmentRequestAgreement) => {
    const newTermList = requestAgreementList.map((item) => {
      if (item.text === selectedTerm.text) {
        return { ...item, selected: !item.selected };
      }
      return item;
    });

    setRequestAgreementList(newTermList);

    const isAgreement = newTermList.every((term) => term.selected);

    const form = treatmentRequest.updateRequestAgreement(isAgreement);
    updateForm(() => form);
  };

  const toggleTreatmentRequestAllAgreement = () => {
    const isAgreement = requestAgreementList.every((term) => term.selected);

    const newTermList = requestAgreementList.map((term) => {
      return { ...term, selected: !isAgreement };
    });
    setRequestAgreementList(newTermList);

    const form = treatmentRequest.updateRequestAgreement(!isAgreement);
    updateForm(() => form);
  };

  const scrollToBottom = () => {
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  };

  const scrollToBottomAndCheckAllAgreement = () => {
    if (client.clientType !== ClientType.WEB) {
      scrollToBottom();
    }
    toggleTreatmentRequestAllAgreement();
  };

  return {
    requestAgreementList,
    toggleTreatmentRequestAgreement,
    toggleTreatmentRequestAllAgreement,
    scrollToBottomAndCheckAllAgreement,
    scrollToBottom,
  };
};
